import { createContext } from "react";

interface DeviceContextType {
  device: Device | undefined;
  refreshDevice: () => Promise<void>;
}

export const DeviceContext = createContext<DeviceContextType | null>(null);
